import { withTransaction } from '@elastic/apm-rum-react';
import { isNil } from 'ramda';
import React, { useEffect } from 'react';

import { BrandType } from '@skytvnz/sky-app-store/lib/types/enums/BrandType';

import { PageType } from '@/Components/HeroBanner';
import DetailsHero from '@/Components/HeroBanner/DetailsHero';
import MovieHeroBanner from '@/Components/HeroBanner/MovieHeroBanner';
import ErrorMessage from '@/Components/Message';
import Synopsis from '@/Components/Synopsis';
import synopsisStyles from '@/Components/Synopsis/styles.module.scss';
import usePackageDetails from '@/Hooks/PUJ/usePackageDetail';
import useBrandDetails from '@/Hooks/useBrandDetails';
import useMedia from '@/Hooks/useMedia';
import usePujFlag from '@/Hooks/usePujFlag';
import Content from '@/Layouts/containers/Content';
import Preloader from '@/Layouts/containers/Preloader';
import Soundtrack from '@/Pages/Detail/Soundtrack';
import WhatsOnTv from '@/Pages/Detail/WhatsOnTv';

import { shouldRefetchForPackageChange } from '@/Utils/Puj';
import { selectors } from '@skytvnz/sky-app-store';
import { useSelector } from 'react-redux';
import { usePrevious } from 'react-use';
import usePinValidationModal from '@/Components/Modal/usePinValidationModal';
import { useContentSubscriptionCheck } from '@/Hooks/useSubscription';
import styles from './styles.module.scss';

const MovieDetail: React.FC = () => {
  const {
    brand: movie,
    image,
    imageType,
    onMyListToggle,
    brandIsLoading,
    refetch,
  } = useBrandDetails('MovieDetail');

  const { hasVodOrLinearPkgUpgrade } = useContentSubscriptionCheck();
  const hasPkgUpgrade = hasVodOrLinearPkgUpgrade(movie);
  const { isPUJEnabled } = usePujFlag();
  const { openPinModal } = usePinValidationModal();
  const { isMediaM } = useMedia();
  const {
    offerText,
    discountPrice,
    packageTitle,
    basePrice,
    hintMessage,
    offerId,
    collectionId,
    collectionTitle,
    actualPrice,
  } = usePackageDetails(movie, movie?.viewingMethods, false);
  const customerPackagesIds = useSelector(selectors.customer.customerPackagesIds);
  const previousCustomerPackagesIds = usePrevious(customerPackagesIds);
  useEffect(() => {
    if (customerPackagesIds && previousCustomerPackagesIds) {
      if (shouldRefetchForPackageChange(movie, customerPackagesIds, previousCustomerPackagesIds)) {
        refetch();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPackagesIds]);

  const packageDetails = {
    isPackageDetailPage: false,
    packagePrice: basePrice,
    packageTitle,
    discountPrice,
    offerText,
    offerId,
    hintMessage,
    collectionId,
    collectionTitle,
    actualPrice,
  };
  return (
    <Preloader isLoading={isNil(movie) && brandIsLoading}>
      {!isNil(movie) && movie.__typename === BrandType.Movie ? (
        <>
          <MovieHeroBanner
            className={styles.heroBanner}
            movie={movie}
            image={image}
            imageType={imageType}
            pageType={PageType.Detail}
            onMyListToggle={onMyListToggle}
            packageDetails={packageDetails}
          />
          {!isMediaM && (
            <Content className={(synopsisStyles.synopsis, styles.movieDetails)}>
              <Synopsis
                synopsis={movie.synopsis}
                cast={movie.characters}
                hasPkgUpgrade={hasPkgUpgrade}
              />
              {isPUJEnabled && (
                <DetailsHero
                  brand={movie}
                  isHome={false}
                  onMyListToggle={onMyListToggle}
                  hasPkgUpgrade={hasPkgUpgrade}
                  packageDetails={packageDetails}
                  openPinModal={openPinModal}
                />
              )}
            </Content>
          )}
          {/* <Trailers />*/}
          <WhatsOnTv brand={movie} />
          <Soundtrack selectedAlbumId={movie.soundtrack?.id} brandId={movie.id} />
          {/* <Similar />*/}
        </>
      ) : (
        <ErrorMessage />
      )}
    </Preloader>
  );
};

export default withTransaction('MovieDetail', 'component')(MovieDetail);
